import { FileResultDto } from 'business/models/Models';
import ExperimentService from 'business/services/ExperimentService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { downloadFilefromUrl, getFileURL, showAlertSnackBar } from 'utils/Global';
import { MIME_TYPES } from 'utils/MimeTypes';

export async function ExportToXMLScreenfromExpId(expId: number, expName: string) {
  const xmlFileData: FileResultDto = await new ExperimentService().getXMlScreenFileData(
    expId,
  );
  if (xmlFileData.success === true) {
    const url = getFileURL(xmlFileData.fileData, 'text/xml');
    downloadFilefromUrl(url, expName + ' - Screen.xml');
    showAlertSnackBar(
      EAlertType.SUCCESS,
      ESnackBarPosition.TOP,
      'File succesfully downloaded!',
    );
  } else {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'Error: ' + xmlFileData.message,
    );
  }
}

export const exportTextScreen = async (
  expName: string,
  wellIds: number[],
  expId = -1,
) => {
  const fileResult = await new ExperimentService().getWellsDataAsTextFile(wellIds, expId);
  if (fileResult.success == true) {
    const url = getFileURL(fileResult.fileData, MIME_TYPES.txt);
    downloadFilefromUrl(url, expName + ' - Wells.txt');
    showAlertSnackBar(
      EAlertType.SUCCESS,
      ESnackBarPosition.TOP,
      'File succesfully downloaded!',
    );
  } else {
    showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, fileResult.message);
  }
};

export async function ExportToXMLExperimentfromExpId(expId: number, expName: string) {
  const xmlFileData: FileResultDto =
    await new ExperimentService().getXMlExperimentFileData(expId);
  if (xmlFileData.success === true) {
    const url = getFileURL(xmlFileData.fileData, 'text/xml');
    downloadFilefromUrl(url, expName + '.xml');
    showAlertSnackBar(
      EAlertType.SUCCESS,
      ESnackBarPosition.TOP,
      'File succesfully downloaded!',
    );
  } else {
    showAlertSnackBar(
      EAlertType.ERROR,
      ESnackBarPosition.TOP,
      'Error: ' + xmlFileData.message,
    );
  }
}
